/** @flow */

export const chartDefaultColors = [
  "#FF871A", // coffee-d1
  "#9E51B2", // berry-d1
  "#3EC9F7", // ice-d1
  "#5BCB42", // mint-d1
  "#004F9F", // ice-d3
  "#5C8068", // mint-d2
  "#786780", // berry-d2
  "#000000",
];
